"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webview_app_1 = require("@/webview_app");
function default_1() {
    window.isNativeApp ? (0, webview_app_1.postMessageToWVA)('RESETSTACK') : (window.location.href = '/');
}
exports.default = default_1;
